// Rota da chamada de áudio ou vídeo (abre por cima de tudo).
import { useLocalSearchParams, useRouter } from 'expo-router';
import { TelaChamada } from '../components/Chamada';
import { useChat } from '../lib/chat';
export { ErrorBoundary } from '../components/Falha';

export default function RotaChamada() {
  const p = useLocalSearchParams<{ conversa: string; tipo: string; nome?: string }>();
  const router = useRouter();
  const conv = useChat().conversas?.find(c => c.id === p.conversa);
  const sair = () => (router.canGoBack() ? router.back() : router.navigate('/mensagens' as any));
  return <TelaChamada conversa={p.conversa} tipo={p.tipo === 'audio' ? 'audio' : 'video'} nome={p.nome || conv?.nome || ''} dupla={conv ? conv.tipo === 'dupla' : true} onFim={sair} />;
}
